import { useEffect } from 'react';
import {
  BOTTOM_LAYER_ABOVE_SATELLITE,
  SATELLITE_LAYER_ID,
  NO_SATELLITE_BACKGROUND,
  STREET_LINES_LAYER_ID,
  WATERWAYS_LAYER_ID,
  WATER_BODIES_LAYER_ID,
  BACKGROUND_COLORS,
  NO_SATELLITE_LAYERS,
} from '../../constants/map';

const NoSatelliteLayer = ({ map }) => {
  useEffect(() => {
    map.addSource('mapbox-streets', {
      type: 'vector',
      url: 'mapbox://mapbox.mapbox-streets-v8',
    });

    map.addLayer(
      {
        id: NO_SATELLITE_BACKGROUND,
        type: 'background',
        paint: {
          'background-color': BACKGROUND_COLORS.light,
        },
        layout: {
          visibility: 'none',
        },
      },
      SATELLITE_LAYER_ID,
    );

    map.addLayer(
      {
        id: WATERWAYS_LAYER_ID,
        source: 'mapbox-streets',
        'source-layer': 'waterway',
        type: 'line',
        paint: {
          'line-color': '#007bbd',
        },
        minZoom: 7,
        layout: {
          visibility: 'none',
        },
      },
      SATELLITE_LAYER_ID,
    );

    map.addLayer(
      {
        id: WATER_BODIES_LAYER_ID,
        source: 'mapbox-streets',
        'source-layer': 'water',
        type: 'line',
        paint: {
          'line-color': '#007bbd',
        },
        minZoom: 0,
        layout: {
          visibility: 'none',
        },
      },
      SATELLITE_LAYER_ID,
    );

    map.addLayer(
      {
        id: STREET_LINES_LAYER_ID,
        source: 'mapbox-streets',
        'source-layer': 'road',
        type: 'line',
        minZoom: 3,
        layout: {
          visibility: 'none',
        },
      },
      BOTTOM_LAYER_ABOVE_SATELLITE,
    );

    return () => {
      // eslint-disable-next-line no-underscore-dangle
      if (map && !map._removed) {
        [STREET_LINES_LAYER_ID, ...NO_SATELLITE_LAYERS].forEach((layerId) =>
          map.removeLayer(layerId),
        );
        map.removeSource('mapbox-streets');
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default NoSatelliteLayer;
